import axios from "axios";
import BaseController from "./BaseController";

export interface PostBlockBlobResponseModel {
  filePath: string;
  baseUri: string;
  path: string;
  uri: string;
  host: string;
}

export default class BlockBlobController extends BaseController {
  constructor(baseUri: string | null) {
    if (baseUri == null) {
      super("https://youngint-devops.azurewebsites.net");
    } else {
      super(baseUri);
    }
  }

  async postAsync(file: Blob | object | any, filePath: string) {
    const params = new URLSearchParams();
    params.append("filePath", `${filePath}`);

    const formdata = new FormData();
    if (file instanceof File || file instanceof Blob) {
      formdata.append("files", file);
    } else {
      const jsonFile = new Blob([JSON.stringify(file)], {
        type: "application/json",
      });
      formdata.append("files", jsonFile);
    }

    const response = await axios.post(
      `${this.hostUrl}/BlockBlob/blob?${params}`,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data as PostBlockBlobResponseModel;
  }
}
